export default {"src":"/_next/static/media/bus-icon.9e475aec.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};